<button
    type="button"
    class=" modal-outline-button-new survey-skip-button"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    placement="bottom"
    #popover="mdbPopover"
    style="border: 1px solid #d7d7d7 !important"
>
    Skip
</button>

<ng-template #content>
  <div class="popover-links "     style="border: 1px solid #d7d7d7 !important">
    <div
        class="popover__action popover__action--border d-flex align-items-center justify-content-center cursor-pointer px-2"
        (click)="postponedForWeek()"
        style="font-size: 14px;"
    >
        <div>Skip for a Week</div>
    </div>
    <div
        class="popover__action popover__action--border d-flex align-items-center justify-content-center cursor-pointer px-2"
        (click)="postponedForMonth()"
        style="font-size: 14px;"
    >
        <div>Skip for a Month</div>
    </div>
    <div
        class="popover__action popover__action--border d-flex align-items-center justify-content-center cursor-pointer px-2"
        (click)="postponedForever()"
        style="font-size: 14px;"
    >
        <div>Skip forever</div>
    </div>
  </div>
</ng-template>
